import React, { useRef, useEffect, useState } from 'react';
import video from '../../assets/vasudharinihomes_video.mp4';
import img from '../../assets/exterior/vasudharinihomes_exterior_2.png';

const Hero = () => {
  const videoRef = useRef(null);
  const containerRef = useRef(null);
  const [videoLoaded, setVideoLoaded] = useState(false);

  useEffect(() => {
    // Lazy loading observer
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && videoRef.current) {
          videoRef.current.load();
          videoRef.current.play().catch(e => console.log("Autoplay prevented:", e));
          observer.unobserve(entry.target);
        }
      });
    }, options);

    const currentContainer = containerRef.current;
    if (currentContainer) {
      observer.observe(currentContainer);
    }

    return () => {
      if (currentContainer) {
        observer.unobserve(currentContainer);
      }
    };

  }, []);

  return (
    <div className='bg-white'>
      <div 
        ref={containerRef}
        className="relative w-full h-[70svh] md:h-svh overflow-hidden"
      >
        {/* Image placeholder until video loads */}
        {!videoLoaded && (
          <img 
            src={img} 
            alt="Vasudharin Homes Exterior" 
            className="w-full h-full object-cover"
          />
        )}
        
        {/* Video element */}
        <video
          ref={videoRef}
          className={`w-full h-full object-cover absolute inset-0 ${videoLoaded ? 'opacity-100' : 'opacity-0'}`}
          autoPlay
          muted
          loop
          playsInline
          onLoadedData={() => setVideoLoaded(true)}
        >
          <source src={video} type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        {/* Optional overlay for better text contrast if needed */}
        <div className="absolute inset-0 bg-black bg-opacity-0"></div>
      </div>
    </div>
  );
};

export default Hero;